import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'src/store';
import { NftSalesAdapter } from './nft-sales.adapter';

export const NftSalesSelect = (state: RootState) =>
    state.global.nftSales;

export const nftSalesSelectors = NftSalesAdapter.getSelectors();

export const selectNftSales = createSelector(
    NftSalesSelect,
    (state) => nftSalesSelectors.selectEntities(state)
);
